/**
 * CheckNodeHelperTask - допоміжні функції для перевірки типів React вузлів
 */

import * as React from 'react'

export class CheckNodeHelperTask {
    /**
     * Перевіряє чи є значення React компонентом
     */
    static isReactComponent(component: any): boolean {
        return (
            typeof component === 'function' ||
            (typeof component === 'object' && component?.$$typeof === Symbol.for('react.element'))
        )
    }

    /**
     * Перевіряє чи є значення MobX observer компонентом
     */
    static isObserver(component: any): boolean {
        component = component || {}
        return (
            (typeof component?.displayName === 'string' && component?.displayName?.includes('observer')) ||
            (typeof component?.name === 'string' && component?.name?.includes('observer')) ||
            false
        )
    }

    /**
     * Перевіряє чи є значення React елементом
     */
    static isElement(element: any): boolean {
        return React.isValidElement(element)
    }
}
